import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=519ec240&scoped=true"
import script from "./CourseItem.vue?vue&type=script&lang=js"
export * from "./CourseItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ec240",
  null
  
)

export default component.exports